// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__fNZiy","inner":"Form_inner__1oklF","range":"Form_range__nkPkA","name":"Form_name__3s29H","actions":"Form_actions__biqjL"};